<div class="datatable-responsive-d-none fw-bold custom-sort text-truncate-no-ellipsis" [attr.title]="title ? (title | messageTranslate) : undefined">
  @if (column['sortable']) {
    <div [ngClass]="{'clickable': !disabled}" (click)="triggerSort($event)">
      <!-- ngx-datatable uses icons from its own font as sort icons. The icons have some spacing built into the actual glyphs.
           So need to use a negative left-margin to move the icons to the left, so that they vertically line up with the contents of the table -->
      <span class="sort-btn" style="margin-left: -3px;"
            [ngClass]="sortDir === SortDirection.asc ? 'datatable-icon-up sort-asc' : sortDir === SortDirection.desc ? 'datatable-icon-down sort-desc' : 'datatable-icon-sort-unset'"></span>
      <ng-template [ngTemplateOutlet]="headerTitle"/>
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="headerTitle"/>
  }
  <ng-template #headerTitle>
    <span>{{column.name | messageTranslate}}</span>
    @if (titleTooltip) {
      <fa-icon icon="circle-info"
               class="ms-1"
               container="body"
               triggers="hover click:blur"
               [ngbTooltip]="titleTooltip | messageTranslate"/>
    }
  </ng-template>
</div>